const BASE_URL ="https://api.xvectortechnologies.com/api/"
const INVOICES = BASE_URL + 'invoice/'
const USER = BASE_URL + 'user/'
const VENDOR = BASE_URL + 'vendor/'
const VENDOR_INFO = BASE_URL + 'vendors-info/'
const FEATCH_VENDOR =BASE_URL + 'featch-vendor/'
const USER_LOGIN = BASE_URL + 'user-login/'
const ORGANIZATION_LOGIN = BASE_URL + 'organization-login/'
const COUNT_DATA = BASE_URL + 'count-data/'
const INVOICES_INFO = BASE_URL + 'invoices-info/'
const ORGANIZATION = BASE_URL + 'organization/'
const USER_INFO = BASE_URL + 'user-info/'
const ORGANIZATION_INFO = BASE_URL+'organization-info/'
const PR_REPORT = BASE_URL + 'pr-report/'
const PR_DELETE = BASE_URL + 'pr-delete/'
const VENDOR_DELETE = BASE_URL +'vendor-delete/'
const VENDOR_UPDATE = BASE_URL + 'vendor-update/'
const PR_UPDATE = BASE_URL + 'pr-invoice-update/'
const CHANGE_PR_STATUS = BASE_URL + 'pr-status-update/'
const PR_SEARCH =   BASE_URL + 'search-payment-recommendation/'
const VENDOR_SEARCH = BASE_URL + 'search-vendor/'
const BANK_ADD = BASE_URL + 'bankdetails/'
const BANK_INFO = BASE_URL + 'bank-info/'
const USER_REPORT = BASE_URL + 'user-report/'
export const ENDPOINTS = {
    INVOICES : INVOICES,
    USER : USER,
    VENDOR : VENDOR,
    VENDOR_INFO : VENDOR_INFO,
    FEATCH_VENDOR : FEATCH_VENDOR,
    USER_LOGIN : USER_LOGIN,
    ORGANIZATION_LOGIN : ORGANIZATION_LOGIN,
    COUNT_DATA : COUNT_DATA,
    INVOICES_INFO : INVOICES_INFO,
    ORGANIZATION : ORGANIZATION,
    USER_INFO : USER_INFO,
    ORGANIZATION_INFO : ORGANIZATION_INFO,
    PR_REPORT : PR_REPORT,
    PR_DELETE : PR_DELETE,
    VENDOR_DELETE : VENDOR_DELETE,
    VENDOR_UPDATE : VENDOR_UPDATE,
    PR_UPDATE : PR_UPDATE,
    CHANGE_PR_STATUS : CHANGE_PR_STATUS,
    PR_SEARCH : PR_SEARCH,
    VENDOR_SEARCH : VENDOR_SEARCH,
    BANK_ADD : BANK_ADD,
    BANK_INFO : BANK_INFO,
    USER_REPORT : USER_REPORT,
}
